import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M10.715-.001a1.5 1.5 0 0 0-1.07.449L1.407 8.645a.5.5 0 0 0-.128.22l-1.26 4.5a.5.5 0 0 0 .616.616l4.5-1.26a.5.5 0 0 0 .22-.128l8.197-8.238.002-.001a1.5 1.5 0 0 0 0-2.128l-.002-.001L11.786.449a1.5 1.5 0 0 0-1.071-.45"
    }, null, -1)
  ]));
}
const Edit = { render };
export {
  Edit as default,
  render
};
//# sourceMappingURL=Edit.svg.js.map
